(function ($) {

  $(document).ready(() => {


    $('.carousel-program').each(function () {
      let slider_program = tns({
        "container": this,
        "edgePadding": 18,
        "fixedWidth": 286,
        "speed": 400,
        "gutter": 18,
        "navPosition": "bottom",
        "responsive": {
          "1200": {
            "items": 4,
            "edgePadding": 0,
            "fixedWidth": false,
            "controls": true,
            "gutter" : 32
          }
        }
      });

      $(this).closest('.block-carousel-programs').find('.prev').on('click', function () {
        slider_program.goTo('prev');
      });

      $(this).closest('.block-carousel-programs').find('.next').on('click', function () {
        slider_program.goTo('next');
      });

    });

  })
})(jQuery);
